var map = {
	"./ion-action-sheet.entry.js": [
		62187,
		2187
	],
	"./ion-alert.entry.js": [
		51921,
		1921
	],
	"./ion-app_8.entry.js": [
		4223,
		4223
	],
	"./ion-avatar_3.entry.js": [
		68808,
		8808
	],
	"./ion-back-button.entry.js": [
		90177,
		177
	],
	"./ion-backdrop.entry.js": [
		78329,
		8329
	],
	"./ion-button_2.entry.js": [
		40242,
		242
	],
	"./ion-card_5.entry.js": [
		9201,
		9201
	],
	"./ion-checkbox.entry.js": [
		35386,
		5386
	],
	"./ion-chip.entry.js": [
		17321,
		7321
	],
	"./ion-col_3.entry.js": [
		75139,
		5139
	],
	"./ion-datetime_3.entry.js": [
		91044,
		1044
	],
	"./ion-fab_3.entry.js": [
		50420,
		420
	],
	"./ion-img.entry.js": [
		79492,
		9492
	],
	"./ion-infinite-scroll_2.entry.js": [
		60664,
		664
	],
	"./ion-input.entry.js": [
		49983,
		9983
	],
	"./ion-item-option_3.entry.js": [
		7890,
		7890
	],
	"./ion-item_8.entry.js": [
		34823,
		4823
	],
	"./ion-loading.entry.js": [
		57823,
		7823
	],
	"./ion-menu_3.entry.js": [
		47538,
		7538
	],
	"./ion-modal.entry.js": [
		47406,
		7406
	],
	"./ion-nav_2.entry.js": [
		81675,
		1675
	],
	"./ion-popover.entry.js": [
		60630,
		630
	],
	"./ion-progress-bar.entry.js": [
		62200,
		2200
	],
	"./ion-radio_2.entry.js": [
		77337,
		7337
	],
	"./ion-range.entry.js": [
		25642,
		5642
	],
	"./ion-refresher_2.entry.js": [
		31802,
		1802
	],
	"./ion-reorder_2.entry.js": [
		44521,
		4521
	],
	"./ion-ripple-effect.entry.js": [
		48779,
		8779
	],
	"./ion-route_4.entry.js": [
		76257,
		6257
	],
	"./ion-searchbar.entry.js": [
		94462,
		4462
	],
	"./ion-segment_2.entry.js": [
		74291,
		4291
	],
	"./ion-select_3.entry.js": [
		50541,
		541
	],
	"./ion-slide_2.entry.js": [
		69031,
		9031
	],
	"./ion-spinner.entry.js": [
		91310,
		1310
	],
	"./ion-split-pane.entry.js": [
		31638,
		1638
	],
	"./ion-tab-bar_2.entry.js": [
		13193,
		3193
	],
	"./ion-tab_2.entry.js": [
		41225,
		1225
	],
	"./ion-text.entry.js": [
		97700,
		7700
	],
	"./ion-textarea.entry.js": [
		5633,
		5633
	],
	"./ion-toast.entry.js": [
		424,
		424
	],
	"./ion-toggle.entry.js": [
		28955,
		8955
	],
	"./ion-virtual-scroll.entry.js": [
		39432,
		9432
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83111;
module.exports = webpackAsyncContext;